/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}scaffold`;
const observedAttributes = {
    VIEWPORT: 'viewport'
};
const attributes = {
    ...observedAttributes
};
export const SCAFFOLD_CONSTANTS = {
    elementName,
    observedAttributes,
    attributes
};
